module.exports = __webpack_public_path__ + "img/image8.222ea65e.png";